import React from "react";
import { hot } from "react-hot-loader/root";

/* Not sure this is all modals, using it to refactor modals contained in Audience tree,
   evaluate later */

import ArchiveModal from "./misc/ArchiveModal";
import LossOfWork from "./misc/LossOfWork";
import TreeItemPickerModal from "./misc/TreeItemPickerModal";
import AudienceRadiusModal from "./audience/AudienceRadiusModal";
import AudienceSingleRadiusModal from "./audience/AudienceSingleRadiusModal";
import AudienceMultipleRadiusModal from "./audience/AudienceMultipleRadiusModal";
import DataDiscoverySelectionsModal from "./misc/DataDiscoverySelectionsModal";
import FieldPickerModal from "./misc/FieldPickerModal";
import FieldLabelsModal from "./fields/FieldLabelsModal";
import FieldLabelDeleteModal from "./fields/FieldLabelDeleteModal";
import GenericDeleteModal from "./GenericDeleteModal";
import CompanyCloneFieldLabelModalConnected2 from "./fields/CompanyCloneFieldLabelModal";
import LayoutDeleteModal from "./layouts/LayoutDeleteModal";
import LayoutCreate from "./layouts/CreateModal";
import LayoutSaveAsModal from "./layouts/SaveAsModal";
import LayoutExportMaterialModal from "./layouts/LayoutExportMaterialModal";
import LayoutPendingSaveModal from "./layouts/LayoutPendingSaveModal";
import DeploymentDetailsModal from "./misc/DeploymentDetailsModal";
import ActivationDetailsModal from "./misc/ActivationDetailsModal";
import DeleteFieldModal from "./misc/DeleteFieldModal";
import DeleteWikiPageModal from "./misc/DeleteWikiPageModal";
import PreviewFlowItemResultsModal from "./flows/PreviewFlowItemResultsModal";
import TableFlowReportPreviewModal from "./flows/TableFlowReportPreviewModal";
import SimpleToLegacyModal from "./flows/SimpleToLegacyModal";
import VariableAdminModal from "./variables/VariableAdminModal";
import VariableGroupingModal from "./variables/VariableGroupingModal";
import UpdateDefaultMinSingleViewCountModal from "./misc/UpdateDefaultMinSingleViewCountModal";
import FlowWaterfallModal from "./flows/FlowWaterfallModal";
import UserCompaniesModal from "./user/UserCompaniesModal";
import UserDetailsModal from "./user/UserDetailsModal";
import ReassignUserItemsModal from "./misc/ReassignUserItemsModal";
import UserDeleteModal from "./user/UserDeleteModal";
import UserTableauAccessModal from "./user/UserTableauAccessModal";
import VariableConfirmDeleteModal from "./variables/VariableConfirmDeleteModal";
import FlowVisibleVariablesModal from "./flows/FlowVisibleVariablesModal";
import FlowMultiExportEditModal from "./flows/FlowMultiExportEditModal";
import FlowFieldsUsedModal from "./flows/FlowFieldsUsedModal";
import FlowOfferCodeValueModal from "./flows/FlowOfferCodeValueModal";
import DisableScriptNodeModal from "./flows/DisableScriptNodeModal";
import NotificationsModal from "./misc/NotificationsModal";
import ModelBundleCreateModal from "./misc/ModelBundleCreateModal";
import ModelBundleDeleteModal from "./misc/ModelBundleDeleteModal";
import UploadAdminFieldsModal from "./misc/UploadAdminFieldsModal";
import DownloadAdminFieldsModal from "./misc/DownloadAdminFieldsModal";
import NewAppSettingsModal from "./admin/NewAppSettingsModal";
import DataDashboardDeleteFileModal from "./flows/DataDashboardDeleteFileModal";
import TestAutomationModal from "./TestAutomationModal";
import DestinationRestrictedFieldsModal from "./flows/DestinationRestrictedFieldsModal";
import DeleteRestrictedFieldModal from "./admin/DeleteRestrictedFieldModal";
import QuickBandingModal from "./misc/QuickBandingModal";
import ManageFeaturesModal from "./admin/ManageFeaturesModal";
import ManageFilesBrowseFilesModal from "./manage-files/browseFilesModal";
import DestinationGroupingParentsModal from "./admin/destinationGroupingParentsModal";
import FileBigSizeUploadWarningModal from "./manage-files/FileBigSizeUploadWarningModal";
import FieldLabelApprovalModal from "./fields/FieldLabelApproval/FieldLabelApprovalModal";
import ScheduleLogModal from "./misc/ScheduleLogModal";
import SessionTimeoutModal from "./SessionTimeoutModal";
import RefreshDeployModal from "./tapad/RefreshDeployConfirmModal";
import UEFieldSearchModal from "./misc/UEFieldSearchModal";
import EditDonorModal from "./make-a-wish/EditDonorModal";
import AddEditGiftModal from "./make-a-wish/AddEditGiftModal";
import TributeTypeModal from "./make-a-wish/TributeTypeModal";
import FlowControlImportLayoutModal from "./misc/FlowControlImportLayoutModal";
import FlowStatusDateFilter from "./misc/FlowStatusDateFilter";
import PreviewModal from "./make-a-wish/PreviewModal";
import DateFilter from "./misc/DateFilter";
import CopyFeaturesModal from "./admin/CopyFeaturesModal";
import ImagesModal from "./wiki/ImagesModal";
import FieldMetaDataModal from "./fields/FieldMetaDataModal";
import FieldShareMetadataModal from "./fields/FieldShareMetadataModal";
import ImportBulkActionModal from "./fields/ImportBulkActionModal";
import ImportBulkLogModal from "./fields/import-bulk-log-modal";
import ImportBulkLogDetailModal from "./fields/Import-bulk-detail-modal";
import ChangeExecutionPriorityModal from "./tools/flowControlDashboard/ChangeExecutionPriorityModal";
import JobDetailsModal from "./tools/flowControlDashboard/JobDetailsModal";
import DestinationDetailModal from "./deployment-destinations/DestinationDetailModal";
import ScriptNodeSearchModal from "./misc/ScriptNodeSearchModal";
import UpdateAssetsActionDetailModal from "./misc/UpdateAssetsActionDetailModal";
import SAAAdvertiserDeleteModal from "./misc/SAAAdvertiserDeleteModal";
import DestinationAccessRequestModal from "./misc/DestinationAccessRequestModal";
import Multiple3PAccessRequestModal from "./misc/Multiple3PAccessRequestModal";
import InsightsInvalidLinkModal from "./misc/InsightsInvalidLinkModal";
import ModelInvalidLink3PModal from "./misc/ModelInvalidLink3PModal";

const AllModals: React.FC = () => (
    <div>
        {/* Currently has bugs while displaying on a CA page, since it changes SelectedAudience: <SchedulesModal /> {/* Comes first - appears under other modals */}
        <ArchiveModal />
        <LossOfWork />
        <TreeItemPickerModal />
        <AudienceRadiusModal />
        <AudienceSingleRadiusModal />
        <AudienceMultipleRadiusModal />
        <DataDiscoverySelectionsModal />
        <FieldPickerModal />
        <FieldLabelsModal />
        <CompanyCloneFieldLabelModalConnected2 />
        <FieldLabelDeleteModal />
        <FieldLabelApprovalModal />
        <GenericDeleteModal />
        <LayoutDeleteModal />
        <LayoutExportMaterialModal />
        <LayoutSaveAsModal />
        <LayoutPendingSaveModal />
        <DisableScriptNodeModal />
        <DeploymentDetailsModal />
        <ActivationDetailsModal />
        <DeleteFieldModal />
        <DeleteWikiPageModal />
        <PreviewFlowItemResultsModal />
        <TableFlowReportPreviewModal />
        <VariableAdminModal />
        <VariableGroupingModal />
        <UpdateDefaultMinSingleViewCountModal />
        <FlowWaterfallModal />
        <FlowMultiExportEditModal />
        <SimpleToLegacyModal />
        <UserCompaniesModal />
        <UserDetailsModal />
        <TestAutomationModal />
        <ReassignUserItemsModal />
        <UserDeleteModal />
        <UserTableauAccessModal />
        <VariableConfirmDeleteModal />
        <FlowVisibleVariablesModal />
        <FlowFieldsUsedModal />
        <FlowOfferCodeValueModal />
        <NotificationsModal />
        <ModelBundleCreateModal />
        <ModelBundleDeleteModal />
        <LayoutCreate />
        <UploadAdminFieldsModal />
        <DownloadAdminFieldsModal />
        <NewAppSettingsModal />
        <DataDashboardDeleteFileModal />
        <DestinationRestrictedFieldsModal />
        <DeleteRestrictedFieldModal />
        <QuickBandingModal />
        <ManageFeaturesModal />
        <ManageFilesBrowseFilesModal />
        <DestinationGroupingParentsModal />
        <FileBigSizeUploadWarningModal />
        <ScheduleLogModal />
        <SessionTimeoutModal />
        <RefreshDeployModal />
        <UEFieldSearchModal />
        <EditDonorModal />
        <AddEditGiftModal />
        <TributeTypeModal />
        <FlowControlImportLayoutModal />
        <FlowStatusDateFilter />
        <PreviewModal />
        <DateFilter />
        <CopyFeaturesModal />
        <ImagesModal />
        <FieldMetaDataModal />
        <FieldShareMetadataModal />
        <ImportBulkActionModal />
        <ImportBulkLogModal />
        <ImportBulkLogDetailModal />
        <ChangeExecutionPriorityModal />
        <JobDetailsModal />
        <DestinationDetailModal />
        <ScriptNodeSearchModal />
        <UpdateAssetsActionDetailModal />
        <SAAAdvertiserDeleteModal />
        <DestinationAccessRequestModal />
        <Multiple3PAccessRequestModal />
        <InsightsInvalidLinkModal />
        <ModelInvalidLink3PModal />
    </div>
);

export default hot(AllModals);
